import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import styles from './EditMerchantModal.module.scss';
import { editMerchant } from '../../api/merchant';
import { toast } from 'react-toastify';

const EditMerchantModal = ({
  show,
  onHide,
  merchant,
  token,
  onSuccess,
  categoryList = [],
  statusList = [],
}) => {
  const [name, setName] = useState('');
  const [category, setCategory] = useState('retail');
  const [status, setStatus] = useState('active');
  const [website, setWebsite] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (merchant) {
      setName(merchant.name || '');
      setCategory(merchant.category || 'retail');
      setStatus(merchant.status || 'active');
      setWebsite(merchant.website || '');
      setPhone(merchant.tel || '');
    }
  }, [merchant]);

  const handleMerchantUpdate = async () => {
    const request = { name, category, status, website, tel: phone };

    try {
      const response = await editMerchant(request, token, merchant.id);
      if (response.message === 'MERCHANT_UPDATED_SUCCESSFULLY') {
        onSuccess();
        onHide();
        toast.success(`${merchant.name} merchant details updated successfully`);
      }
    } catch (error) {
      console.error('Error updating merchant:', error);
    }
  };

  // Reusable input field
  const renderInput = ({
    id,
    label,
    type = 'text',
    placeholder,
    value,
    onChange,
  }) => (
    <div className={styles.formGroup}>
      <label htmlFor={id}>{label}</label>
      <input
        type={type}
        id={id}
        className={styles.inputField}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );

  // Reusable select field
  const renderSelect = ({
    id,
    label,
    options = [],
    value,
    onChange,
    emptyMessage,
  }) => (
    <div className={styles.formGroup}>
      <label htmlFor={id}>{label}</label>
      <select
        id={id}
        className={styles.selectField}
        value={value}
        onChange={onChange}
      >
        {options.length > 0 ? (
          options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))
        ) : (
          <option value=''>{emptyMessage}</option>
        )}
      </select>
    </div>
  );

  return (
    <Modal
      show={show}
      className={styles.editMerchantModal}
      onHide={onHide}
      size='lg'
      centered
      backdrop={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Merchant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {renderInput({
          id: 'merchantName',
          label: 'Merchant Name',
          placeholder: 'Enter merchant name',
          value: name,
          onChange: (e) => setName(e.target.value),
        })}

        {renderSelect({
          id: 'merchantCategory',
          label: 'Merchant Category',
          options: categoryList,
          value: category,
          onChange: (e) => setCategory(e.target.value),
          emptyMessage: 'No categories',
        })}

        {renderSelect({
          id: 'merchantStatus',
          label: 'Merchant Status',
          options: statusList,
          value: status,
          onChange: (e) => setStatus(e.target.value),
          emptyMessage: 'No statuses',
        })}

        {renderInput({
          id: 'merchantWebsite',
          label: 'Merchant Website',
          type: 'url',
          placeholder: 'Enter merchant website URL',
          value: website,
          onChange: (e) => setWebsite(e.target.value),
        })}

        {renderInput({
          id: 'merchantPhone',
          label: 'Merchant Phone',
          type: 'tel',
          placeholder: 'Enter merchant phone number',
          value: phone,
          onChange: (e) => setPhone(e.target.value),
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
        <Button variant='primary' onClick={handleMerchantUpdate}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditMerchantModal;
